
import React from 'react';
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";

interface RejectedClientsTableProps {
  rejectedClients: any[];
  handleRequestAction: (request: any) => void;
  isProcessing: boolean;
  handleDeleteClient?: (request: any) => void;
}

const RejectedClientsTable: React.FC<RejectedClientsTableProps> = ({
  rejectedClients,
  handleRequestAction,
  isProcessing,
  handleDeleteClient
}) => {
  return (
    <div className="overflow-x-auto">
      <Table>
        <TableCaption>List of rejected clients</TableCaption>
        <TableHeader>
          <TableRow>
            <TableHead>Company</TableHead>
            <TableHead>Contact Name</TableHead>
            <TableHead>Email</TableHead>
            <TableHead>Phone</TableHead>
            <TableHead>Rejected Date</TableHead>
            <TableHead>Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {rejectedClients.map((client) => (
            <TableRow key={client.id}>
              <TableCell className="font-medium">{client.company_name}</TableCell>
              <TableCell>{client.full_name}</TableCell>
              <TableCell>{client.email}</TableCell>
              <TableCell>{client.phone || '-'}</TableCell>
              <TableCell>{new Date(client.updated_at).toLocaleDateString()}</TableCell>
              <TableCell className="flex gap-2">
                <Button 
                  variant="outline" 
                  size="sm"
                  onClick={() => handleRequestAction(client)}
                  disabled={isProcessing}
                >
                  Change Status
                </Button>
                {handleDeleteClient && (
                  <Button 
                    variant="destructive" 
                    size="sm"
                    onClick={() => handleDeleteClient(client)}
                    disabled={isProcessing}
                  >
                    <Trash2 className="h-4 w-4" />
                  </Button>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default RejectedClientsTable;
